import CurrentUserEditMutation from '@/graphql/mutations/CurrentUserEdit.gql';
import qs from 'querystring';

export default {
  methods: {
    async connectedCommunicationChannelProvider() {
      const response = typeof this.$route.hash === 'string' ? qs.parse(this.$route.hash.substr(1)) : null;
      this.$log.debug(response);

      console.log({ response });

      const {
        access_token: accessToken,
        userAccessToken,
        refresh_token: refreshToken,
        token_type: tokenType,
        expires_in: expiresIn,
        scope,
      } = response;

      this.$assert(accessToken || userAccessToken, 'Missing accessToken from communication channel provider');

      const { id: userID } = this.user;
      let update = null;
      if (this.$route.query.callback !== 'slack') {
        update = {
          state: {
            [this.$route.query.callback === 'google' ? 'gmail' : this.$route.query.callback]: {
              provider: this.$route.query.callback,
              accessToken,
              refreshToken,
              tokenType,
              expiresAt: refreshToken ? (new Date()).getTime() + (parseInt(expiresIn) * 1000) : null,
              expiresIn,
              scope,
            },
          },
        };
      } else {
        const { userAccessToken: accessToken, ...rest } = response;
        this.$assert(accessToken, 'Missing accessToken from Slack provider');
        update = {
          state: {
            slack: {
              provider: this.$route.query.callback,
              accessToken,
              ...rest,
            },
          },
        };
      }

      this.$log.debug({ update });

      await this.$apollo.mutate({
        mutation: CurrentUserEditMutation,
        variables: { userID, update },
      });

      // Clear callback query & auth details from URL
      this.$router.replace({ ...this.$route, query: null, hash: '' });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/communicationChannelProvider.js